import { useEffect, useState } from "react";
import { Job as JobDetailType } from "@type/job";
import { getJobDetail, getJobDetailGuest } from "@service/job";
import { useParams } from "react-router"
import { getCookie } from "@util/cookie";
import { JobNotFound } from "@container/job-not-found";
import JobDetail from "@container/job-detail";
import BasicLayout from "@container/layout/basic";
import { useQuery } from "@util/useQuery";
import { trackEvent } from "@util/mixpanel";

export default function JobDetailPage() {
    const params = useParams()
    const queryParams = useQuery()
    const token = getCookie("authToken");

    const [job, setJob] = useState<JobDetailType | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    const fetchJobDetail = async () => {
        try {
            setIsLoading(true);
            let jobDetail: JobDetailType | null = null;
            if (!token) {
                jobDetail = await getJobDetailGuest(params.jobid || "");
            } else {
                jobDetail = await getJobDetail(params.jobid || "");
            }

            trackEvent('job_detail_viewed', {
                job_id: jobDetail.id,
                job_title: jobDetail.job_title,
                company_name: jobDetail.company_name,
                location: jobDetail.location,
                utm_source: queryParams.get("utm_source") || "",
                utm_medium: queryParams.get("utm_medium") || "",
                utm_campaign: queryParams.get("utm_campaign") || "",
                job_referral_code: queryParams.get("referral") || "",
            })
            setJob(jobDetail);

        } catch (error) {
            setJob(null);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (params.jobid !== "") {
            fetchJobDetail();
        }
    }, [params.jobid]);

    if (isLoading) {
        return (
            <div className="flex justify-center items-center py-12">
                <div className="animate-spin h-8 w-8 border-4 border-blue-500 border-t-transparent rounded-full"></div>
            </div>
        );
    }

    return (
        <BasicLayout
            disableMinHeight
            isHideLoginButton={job?.company_is_quick_apply}
            cssMain="mx-auto max-w-7xl w-full"
        >
            {job ? (
                <JobDetail
                    job={job}
                    isGuestMode={token === "" || token === undefined}
                />
            ) : (
                <JobNotFound />
            )}
        </BasicLayout>
    )
}
